import React from "react";
import { connect } from "react-redux";

import { EHR_REQUEST_MODAL } from "components/modals";
import SimpleModal from "components/modals/SimpleModal";
import File from "components/File";
import { fetchInsured, fetchCaseFilesByCaseDocumentId, generateEHRRequest, hideModal } from "actions";
import {
  activeCaseFileSelector,
  activeOrderFilesSelector,
  loadingSelector,
  insuredListSelector,
  activeCaseSelector,
} from "reducers";
import { Table } from "react-bootstrap";

const EHRRequestModal = ({ ...props }) => {
  const [result, setResult] = React.useState(null);
  React.useEffect(() => {
    async function fetchData() {
      const ehrRequest = await props.generateEHRRequest(props.activeCaseFile.id, props.caseInfo.id);
      setResult(ehrRequest?.result);
    }
    fetchData();
  }, []);

  const SendButton = () => {
    let message = "OK";
    if (props.loading?.ehr) {
      message = (
        <>
          Processing... <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
        </>
      );
    }

    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn btn--secondary"
          onClick={async () => {
            props.hideModal(EHR_REQUEST_MODAL);
          }}
          style={{ width: "50%", marginBottom: "1rem" }}
        >
          {message}
        </button>
      </div>
    );
  };

  const Review = () => {
    let orderFile = "";
    if (props.activeCaseFile?.order_file) {
      orderFile = (
        <File
          style={{ marginBottom: 0 }}
          file={props.activeCaseFile.order_file}
          fileDownloadUrl={props.activeCaseFile.order_file.url}
        />
      );
    }

    let formattedResult = [];
    if (result) {
      formattedResult.push(
        <div key="patient" style={{ textAlign: "left" }}>
          <strong>Patient:</strong> {result.patient_name}
        </div>,
      );
      formattedResult.push(
        <div key="pageCount" style={{ textAlign: "left" }}>
          <strong>PDF Page Count:</strong> {result.page_count}
        </div>,
      );
      if (result.alert) {
        formattedResult.push(
          <div key="alert" style={{ textAlign: "left" }}>
            <strong>Alert:</strong> {result.alert}
          </div>,
        );
      }
    }

    return (
      <>
        <Table striped bordered hover>
          <div style={{ marginLeft: 10, padding: 15, textAlign: "center" }}>
            <h5>EHR Progress Notes</h5>
            {orderFile && !props.loading?.ehr && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 15,
                }}
              >
                {orderFile}
              </div>
            )}
            <div style={{ display: "inline-block", textAlign: "left" }}>{formattedResult}</div>
          </div>
        </Table>
        <SendButton />
      </>
    );
  };

  return (
    <SimpleModal modalType={EHR_REQUEST_MODAL} title={"EHR Progress Notes"}>
      <Review />
    </SimpleModal>
  );
};

const mapStateToProps = state => {
  return {
    caseInfo: activeCaseSelector(state),
    activeCaseFile: activeCaseFileSelector(state),
    activeOrderFiles: activeOrderFilesSelector(state),
    insuredList: insuredListSelector(state),
    loading: loadingSelector(state),
  };
};

export default connect(mapStateToProps, {
  generateEHRRequest,
  fetchInsured,
  fetchCaseFilesByCaseDocumentId,
  hideModal,
})(EHRRequestModal);
